var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getDateHumanize, timeFormat, useForceUpdate } from "../../../lib/misc.functions";
import { Event } from "../components/event";
import React, { useEffect, useMemo } from "react";
import { mobileHighLightedMarket, myHighLightedMarketGroups } from "../../../services/sportsbook.services";
import { getFromLanguageFile, isMobileView } from "../../../app";
import { useTranslation } from "react-i18next";
export function Eventlist(props) {
    // let visibleSportsBook:any = [];
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    var shownSportsBook = props.shownSportsBook;
    var params = props.params;
    var width = window.innerWidth;
    var forceUpdate = useForceUpdate();
    var openEventDetail = props.openEventDetail;
    var showEventDetail = props.showEventDetail;
    var page = props.page || 0;
    var prevLabel = '';
    var getHeader = function (label, sportSlug) {
        var _a;
        if (prevLabel != label) {
            prevLabel = label;
            if (label) {
                var competitionGroupName = label.split('__')[0];
                var competitionName = label.split('__')[1];
                var countryName = label.split('__')[2];
                var date_1 = label.split('__')[3];
                return (_jsx("div", __assign({ className: "c-segment-holder-bc head" }, { children: _jsxs("div", __assign({ className: "c-head-bc" }, { children: [_jsxs("div", __assign({ className: "c-title-bc ellipsis d-flex align-items-center " }, { children: [_jsx("i", { className: "sp-s-l-h-flag-bc flag-bc ".concat((_a = countryName === null || countryName === void 0 ? void 0 : countryName.toString().toLowerCase()) === null || _a === void 0 ? void 0 : _a.replaceAll(' ', '_').replaceAll('(', '').replaceAll(')', '')) }, void 0), _jsx("div", __assign({ className: "sp-s-l-h-title-content ellipsis" }, { children: _jsxs("p", __assign({ className: "sp-s-l-h-title-bc ellipsis" }, { children: [competitionGroupName.replaceAll(competitionName, ''), " ", competitionName] }), void 0) }), void 0)] }), void 0), !isMobileView && _jsx("div", __assign({ className: "sp-s-l-h-title-content ellipsis" }, { children: _jsxs("p", __assign({ className: "sp-s-l-h-title-bc ellipsis" }, { children: [t(date_1.split(' ')[0]), " ", date_1.split(' ')[1]] }), void 0) }), void 0)] }), void 0) }), void 0));
            }
            else {
                return (_jsx(React.Fragment, {}, void 0));
            }
        }
        else {
            return (_jsx(React.Fragment, {}, void 0));
        }
    };
    var vh = window.outerHeight;
    var pageSize = vh / 50;
    useEffect(function () {
        forceUpdate();
    }, [page]);
    var date = "";
    var MemoList = function () {
        return (_jsx(React.Fragment, { children: shownSportsBook.slice(0, ((page + 1) * pageSize)).map(function (event, key) {
                date = getDateHumanize(event.eD);
                return (_jsxs("div", __assign({ className: "competition-bc" }, { children: [getHeader("".concat(getFromLanguageFile(event.cGNId) ? getFromLanguageFile(event.cGNId) : event.cGN, "__").concat(getFromLanguageFile(event.cNId) ? getFromLanguageFile(event.cNId) : event.cN, "__").concat(event.coN, "__").concat(date, " ").concat(timeFormat(event.eD), "__").concat(event.sS), event.sS), !isMobileView && _jsx("ul", __assign({ id: "eventId_" + event.eventId, className: "multi-column-content ".concat((showEventDetail === null || showEventDetail === void 0 ? void 0 : showEventDetail.eventId) === event.eventId ? ' active ' : '', "  multi-column-show-type-undefined") }, { children: _jsx(Event, { id: "eventId_" + event.eventId, event: event, eventType: params.eventType, context: openEventDetail }, "eventId_" + event.eventId) }), void 0), isMobileView &&
                            _jsx("div", __assign({ id: "eventId_" + event.eventId, className: "c-segment-holder-bc single-g-info-bc" }, { children: _jsx(Event, { event: event, id: "eventId_" + event.eventId, eventType: params.eventType, context: openEventDetail }, "eventId_" + event.eventId) }), "list" + key)] }), "list" + key));
            }) }, void 0));
    };
    var result = useMemo(function () { return MemoList(); }, [page, params.sportSlug, params.eventType, JSON.stringify(props.sportsbookFilter), JSON.stringify(myHighLightedMarketGroups), JSON.stringify(mobileHighLightedMarket), i18n.language]);
    return result;
}
